/**
 * Environment related constants that are used globally.
 */
export const CRL_DOMAIN = 'https://library.exchange.aboutamazon.com';
export const ENV_STAGE = 'prod';
